import { useTranslation } from 'react-i18next'
import { Settings2 } from 'lucide-react'

/**
 * Moduleinstellungen — placeholder for the future action-module wizard. Out of scope in
 * this slice; the tab is visible so the target location is discoverable.
 */
export default function ModuleSettingsTab() {
  const { t } = useTranslation('action-modules-detail')
  return (
    <div className="mt-4 flex flex-1 flex-col items-center justify-center gap-2 rounded-lg border py-16 text-muted-foreground">
      <Settings2 className="size-12 opacity-30" />
      <p className="text-sm">{t('settings.comingSoon')}</p>
    </div>
  )
}
